<template>
    <Button :icon="attrs.icon" @click="handleClick" :loading="isLoading" v-if="isDisplay">
        {{attrs.title}}
    </Button>
</template>
<script>
    /**
     * 处理删除逻辑的按钮
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    export default {
        name: 'LyDeleteButton',
        mixins: [CompEventMixin, CompDisplayMixin],
        props: {
            row: {
                type: Object,
                default: _ => new Object()
            } // 提供给tabel，用于绑定行数据
        },
        data () {
            return {
                isLoading: false // 标识，是否是在提交
            }
        },
        methods: {
            /**
             * 按钮点击的监听
             */
            handleClick () {
                this.$Modal.confirm({
                    title: '操作确认',
                    content: '<p>你确定要删除？</p>',
                    onOk: () => {
                        this.doDelete()
                    }
                })
            },
            /**
             * 进行删除的操作
             */
            doDelete () {
                this.isLoading = true
                let url = this.attrs.api 
                let backRoute = this.attrs.route // 删除成功后的跳转路由
                // row有字段说明是表格中传递过来的
                if (this.row.hasOwnProperty('id')) {
                    url = this.$path.getPath(url, this.row)
                } else {
                    url = this.$path.getPath(url, this.page)
                    // 表格删除没有跳转
                    backRoute = this.$path.getPath(backRoute, this.page)
                }

                // 2010-03-21 批量审核加入的专有属性
                if (this.attrs.isBatchAudit) {
                    // 将提交的数据和url发送出去
                    this.$eventHub.$emit(this.$events.BATCH_AUDIT_SUBMIT_DATA, {
                        url: url,
                        method: 'delete'
                    })
                    this.isLoading = false
                } else{
                    this.$api.delete(url).then(() => {
                        this.isLoading = false
                        this.$Message.success('删除成功')
                        // 如果过是表格中传递过来的数据，通知刷新当前页面
                        if (this.row.hasOwnProperty('id')) {
                            // 发送刷新页面数据的事件
                            this.$eventHub.$emit(this.$events.REFRESH_SEARCH_DATA)
                        } else { // 跳转路由                
                            if (this.attrs.route.length > 0) {       
                                this.$router.push({path: backRoute})
                            } else { // 如果没有指定路由，跳转到上个页面
                                this.$router.go(-1)
                            }
                        }
                    }).catch((err) => {
                        this.isLoading = false
                        console.error(err)
                        this.$Message.error({content: err, duration: 5 })
                    })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/delete-button/src/index.vue